import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { X } from 'react-feather';
import styles from './DrawerPanel.module.scss';

export default function DrawerPanel({ isOpen, onClose, title, children, width = 480 }) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} aria-hidden="true" />
      <aside className={styles.panel} style={{ width }} role="dialog" aria-modal="true" aria-label={title}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <Button variant="light" size="sm" onClick={onClose} aria-label="Close">
            <X size={18} />
          </Button>
        </div>
        <div className={styles.body}>{children}</div>
      </aside>
    </>
  );
}
